var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"change-store-icon",style:({zIndex: 10}),on:{"click":_vm.changeStore}},[_c('img',{staticClass:"change-store-icon-img",attrs:{"width":"14","height":"14","src":require("@/assets/images/store/changeStore.png"),"alt":"changeStore"}}),_c('span',{staticClass:"change-store-icon-text"},[_vm._v("切换店铺")])])
}
var staticRenderFns = []

export { render, staticRenderFns }